<div
  #textContainer
  class="tw-relative tw-w-full tw-h-[60px] tw-overflow-hidden tw-rounded-md tw-mx-auto"
  >
  <p #textContent class="tw-text-gray-700 tw-m-0 tw-break-words">
    {{ displayText }}
    @if (isOverflowing) {
      @if (!isExpanded) {
        <span>&hellip;</span>
      }
      <div (click)="toggleText()"
        class="tw-text-gray-800 tw-font-bold tw-hover:underline tw-inline tw-border-0 tw-p-0 tw-bg-transparent">
        @if (!isExpanded) {
          <span i18n="@@readMore">Read More</span>
        }
        @if (isExpanded) {
          <span i18n="@@readLess">Read Less</span>
        }
      </div>
    }
  </p>
</div>
